import * as React from "react";
import {ISvgIconProps, SvgIcon} from '../../../basic-ui-components/icon/svg-icon/svg.icon';


export interface ISafeZoneIconProps extends ISvgIconProps {

}

export class SafeZoneIcon extends React.Component<ISafeZoneIconProps, {}> {
    render() {
        return (
            <SvgIcon {...this.props}>
                <g>
                    <path
                        fill="currentColor"
                        d="M19.3,5.42l-7-3.37-.12,0-.31,0-7,3.37a1.36,1.36,0,0,0-.76,1.24C4.19,14.33,6.81,19.47,11.85,22l.09.05h.24l.1-.05c5-2.48,7.66-7.62,7.78-15.29A1.34,1.34,0,0,0,19.3,5.42ZM16.4,9l-4.49,7a1,1,0,0,1-.82.46h0a1,1,0,0,1-.81-.42l-2.5-3.54a1,1,0,0,1,1.63-1.16L11,13.71,14.72,8A1,1,0,0,1,16.4,9Z"
                    />
                </g>
            </SvgIcon>
        );
    }
}
